import { createIcon } from './createIcon';

/** Account — a head and shoulders, the universal "this is you". */
export const AccountIcon = createIcon({
  name: 'AccountIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <>
      <circle
        cx="8"
        cy="5.25"
        r="2.75"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M2.75 13.75c0-2.4 2.35-4 5.25-4s5.25 1.6 5.25 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
});

export default AccountIcon;
